/** "On this page": the article's headings, the one in view highlighted. */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';

export default function OnThisPage({ headings }) {
  const [activeId, setActiveId] = useState(headings?.[0]?.id || null);

  useEffect(() => {
    if (!headings?.length || typeof IntersectionObserver === 'undefined') return undefined;
    const els = headings.map((h) => document.getElementById(h.id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: '-96px 0px -65% 0px' },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [headings]);

  if (!headings?.length) return null;
  return (
    <nav aria-label="On this page" className="text-[13.5px]">
      <p className="mb-3 text-[11px] uppercase tracking-[0.18em] text-white/40">On this page</p>
      <ul className="space-y-1 border-l border-white/10">
        {headings.map((h) => (
          <li key={h.id}>
            <a
              href={`#${h.id}`}
              className={cn(
                '-ml-px block border-l py-1 leading-snug transition-colors',
                h.level === 3 ? 'pl-6' : 'pl-3',
                activeId === h.id ? 'border-[#AAB4D6] text-white' : 'border-transparent text-white/50 hover:text-white',
              )}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
OnThisPage.propTypes = { headings: PropTypes.array };
